import React from "react";
import Page from "../../common/page/Page.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import useTranslationChatGpt from "../useTranslationChatGpt.js";
import ChatGptBlock from "./ChatGptBlock.js";

export default function ChatGptPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationChatGpt();
  useShowLoader(tLoading, "ChatGptPage");

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="ChatGptPage">
          <Page.Title
            text={t("chatgpt:page_title")}
            loading={tLoading}
          />
          <Page.Content>
            <ChatGptBlock/>
          </Page.Content>
        </Page>
      )}
    />
  );
}
